<template>
  <v-layout>
    <!-- DIALOG ConfirmarAccion -->
    <v-dialog v-model="dialog" max-width="450">
      <v-card class="py-3">
        <v-card-title class="headline"> Finalizar Turno </v-card-title>
        <v-card-text class="subtitle-1">
          Confirmar esta acción finalizara el tunno del operador de grua
          <span class="font-weight-medium"
            >"{{
              selectedHistorial != null ? selectedHistorial.operadorGrua : ""
            }}"</span
          >, con la grúa
          <span class="font-weight-medium"
            >"
            {{
              selectedHistorial != null ? selectedHistorial.proveedor : ""
            }}".</span
          >
        </v-card-text>
        <v-card-actions class="px-6">
          <v-btn color="primary" outlined @click="limpiar"> Cancelar </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="cerrarTurnoAdmin"> Aceptar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-flex class="px-10 py-5">
      <v-data-table
        :headers="headers"
        :items="historialGruas"
        :loading="loader"
        loading-text="Listando Datos..."
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-container class="px-5 py-4">
            <v-layout>
              <h2 class="py-2 pl-3">Historial de Operadores - Grúas</h2>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row class="mt-6 mb-4">
              <v-flex xs12 sm12 md3 class="px-2">
                <v-text-field
                  class="text-xs-center"
                  v-model="search"
                  append-icon="search"
                  label="Búsqueda"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>

              <v-flex xs12 sm12 md2 class="px-2">
                <v-text-field
                  v-model="fechaInicio"
                  type="date"
                  hide-details
                  label="Inicio"
                  :max="new Date().toISOString().substr(0, 10)"
                  clearable
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md2 class="px-2">
                <v-text-field
                  v-model="fechaFin"
                  type="date"
                  hide-details
                  label="Fin"
                  :max="new Date().toISOString().substr(0, 10)"
                  clearable
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md1 class="text-center pt-3" align-self-center>
                <v-btn color="blue" dark @click="listarHistorial" block>
                  Listar
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md1 class="text-center pt-3" align-self-center>
                <v-btn
                  color="green"
                  :block="$vuetify.breakpoint.smAndDown"
                  dark
                  @click="formatReporte"
                >
                  <v-icon class="ml-2">fas fa-file-excel</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
        </template>

        <template v-slot:[`item.archivos`]="{ item }">
          <v-btn
            v-if="item.detalles && item.detalles.length > 0"
            icon
            color="primary"
            @click="verArchivos(item)"
          >
            <v-icon>fas fa-folder-open</v-icon>
          </v-btn>

          <span v-else>- - - -</span>
        </template>
        <template v-slot:[`item.fechaInicio`]="{ item }">
          {{ formatDate(item.fechaInicio) }}
        </template>
        <template v-slot:[`item.fechaFin`]="{ item }">
          {{ formatDate(item.fechaFin) }}
        </template>
        <template v-slot:[`item.horaFin`]="{ item }">
          {{ item.horaFin == null ? "- - - -" : item.horaFin }}
        </template>
        <template v-slot:[`item.opciones`]="{ item }">
          <v-tooltip top color="red">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                color="red"
                :disabled="!item.estado"
                @click="confirmarFinalizarTurno(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>fa fa-times</v-icon>
              </v-btn>
            </template>
            <span>Finalizar Turno</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <v-chip :color="item.estado ? 'green' : 'red'" dark>
            {{ item.estado ? "Activo" : "Finalizado" }}
          </v-chip>
        </template>
      </v-data-table>
    </v-flex>
    <ArchivosHistorialGrua
      v-if="historialArchivos"
      :ruta-base="historialArchivos.rutaBase"
      :dialog.sync="dialogArchivos"
      :observacion="selectedHistorial.observacionEncargado"
      :historialOperadorId="selectedHistorial.id"
      :detalles="detallesHistorial"
      @actualizar-listado="listarHistorial"
    />
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import XLSX from "xlsx";
import ArchivosHistorialGrua from "@/components/ArchivosHistorialGrua.vue";

export default {
  components: {
    ArchivosHistorialGrua,
  },
  data() {
    return {
      dialogArchivos: false,
      historialArchivos: null,
      detallesHistorial: null,
      text: "Historial Gruas",
      search: "",
      loader: false,
      dialog: false,
      selectedHistorial: null,
      fechaInicio: new Date().toISOString().substr(0, 10),
      fechaFin: new Date().toISOString().substr(0, 10),
      historialGruas: [],
      headers: [
        {
          text: "Id",
          value: "id",
          sortable: false,
          width: 100,
          align: "center",
        },
        {
          text: "Grúa",
          value: "proveedor",
          sortable: true,
          align: "center",
        },
        {
          text: "Operador Grúa",
          value: "operadorGrua",
          sortable: true,
          align: "center",
        },
        {
          text: "Fecha Inicio",
          value: "fechaInicio",
          sortable: true,
          align: "center",
          width: 120,
        },
        {
          text: "Hora Inicio",
          value: "horaInicio",
          sortable: true,
          align: "center",
          width: 120,
        },
        {
          text: "Fecha Fin",
          value: "fechaFin",
          sortable: true,
          align: "center",
          width: 120,
        },
        {
          text: "Hora Fin",
          value: "horaFin",
          sortable: true,
          align: "center",
          width: 120,
        },
        {
          text: "Estado",
          value: "estado",
          sortable: true,
          align: "center",
          width: 100,
        },
        {
          text: "Archivos",
          value: "archivos",
          sortable: false,
          align: "center",
        },
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
        },
      ],
    };
  },
  created() {
    const today = new Date();
    const firstDayInMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.fechaInicio = firstDayInMonth.toISOString().substring(0, 10);
    this.inicioReporte = this.fechaInicio;

    this.listarHistorial();
    this.listarOperadoresGrua();
  },
  computed: {
    mensajeBienvenida() {
      return (
        `Bienvenido/a, ${this.$store.state.usuario.nombre}!` || `Bienvenido/a!`
      );
    },
  },
  methods: {
    verArchivos(item) {
      if (!item.detalles || item.detalles.length === 0) return;

      this.selectedHistorial = item;

      const detalle = item.detalles.find((detalle) => detalle.rutaBase);

      if (!detalle) return;

      this.historialArchivos = detalle;
      this.detallesHistorial = item.detalles;
      this.dialogArchivos = true;
    },
    confirmarFinalizarTurno(item) {
      this.dialog = true;
      this.selectedHistorial = item;
    },
    limpiar() {
      this.selectedHistorial = null;
      this.dialog = false;
    },
    cerrarTurnoAdmin() {
      if (this.selectedHistorial == null) return;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          `api/HistorialOperadoresGrua/CerrarTurno/${this.selectedHistorial.operadorGruaId}`,
          null,
          configuracion,
        )
        .then((res) => {
          if (res.data) {
            this.listarHistorial();
            this.limpiar();
          }
        })
        .catch((err) => console.error(err));
    },
    listarOperadoresGrua() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/OperadoresGruas/Listar", configuracion)
        .then((res) => {
          this.operadoresGrua = res.data;
        })
        .catch((err) => console.error(err));
    },
    ExportarExcel(listado) {
      let data = XLSX.utils.json_to_sheet(listado);
      const workbook = XLSX.utils.book_new();
      const filename = `Operadores Grúa ${this.fechaInicio.toString(
        "yyyy-MM-dd",
      )} a ${this.fechaFin.toString("yyyy-MM-dd")}`;

      data["!cols"] = [
        { wch: 15 },
        { wch: 27 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 50 },
      ];
      XLSX.utils.book_append_sheet(workbook, data, "Historial");
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    formatReporte() {
      const formatDate = (date) => {
        if (!date) return "";
        return new Date(date).toISOString().split("T")[0];
      };

      const listadoHistorial = this.historialGruas.map((data) => {
        const historial = {
          Proveedor: data.proveedor,
          OperadorGrua: data.operadorGrua,
          "Fecha Inicio": formatDate(data.fechaInicio),
          "Hora Inicio": data.horaInicio,
          "Fecha Fin": formatDate(data.fechaFin),
          "Hora Fin": data.horaFin,
          "Observación Encargado": data.observacionEncargado,
          Estado: data.estado ? "Activo" : "Finalizado",
        };

        delete historial.id;
        delete historial.proveedorId;
        delete historial.operadorGruaId;

        return historial;
      });

      this.ExportarExcel(listadoHistorial);
    },
    listarHistorial() {
      this.loader = true;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/HistorialOperadoresGrua?fechaInicio=${this.fechaInicio}&fechaFin=${this.fechaFin}`,
          configuracion,
        )
        .then((res) => {
          this.historialGruas = res.data;
        })
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    formatDate(fecha) {
      if (fecha == null) return "- - - -";
      if (!fecha || typeof fecha != "string") {
        throw new Error(
          "El parametro 'fecha' debe ser de tipo String y no puede estar vacio",
        );
      }

      return moment(fecha).format("YYYY-MM-DD");
    },
  },
};
</script>
